import { useToastStore } from '../../../hooks/useToast';

const toneStyles = {
    success: 'border-success/25 bg-success/95 text-white',
    error: 'border-error/25 bg-error text-white',
    info: 'border-info/25 bg-info text-white',
} as const;

export function ToastViewport() {
    const items = useToastStore((state) => state.items);
    const dismissToast = useToastStore((state) => state.dismiss);

    if (items.length === 0) {
        return null;
    }

    return (
        <div
            className="pointer-events-none fixed inset-x-0 bottom-0 z-[1200] flex flex-col items-center gap-2 px-4 pb-[calc(1rem+var(--spacing-safe-bottom,0px))]"
            aria-live="polite"
            aria-atomic="true"
        >
            {items.map((item) => (
                <section
                    key={item.id}
                    className={[
                        'pointer-events-auto flex w-full max-w-md items-start gap-3 rounded-2xl border px-4 py-3 shadow-lg backdrop-blur',
                        toneStyles[item.tone],
                    ].join(' ')}
                    role={item.tone === 'error' ? 'alert' : 'status'}
                >
                    <div className="min-w-0 flex-1">
                        {item.title ? <p className="text-sm font-semibold">{item.title}</p> : null}
                        <p className="text-sm leading-5">{item.message}</p>
                    </div>
                    {item.actionLabel && item.onAction ? (
                        <button
                            type="button"
                            className="touch-manipulation rounded-lg border border-white/20 px-3 py-2 text-xs font-semibold text-white transition hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
                            onClick={() => {
                                dismissToast(item.id);
                                item.onAction?.();
                            }}
                        >
                            {item.actionLabel}
                        </button>
                    ) : null}
                    <button
                        type="button"
                        className="touch-manipulation rounded-lg px-2 py-1 text-xs font-semibold text-white/90 transition hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
                        onClick={() => dismissToast(item.id)}
                        aria-label="Cerrar notificacion"
                    >
                        Cerrar
                    </button>
                </section>
            ))}
        </div>
    );
}